// Task types and mock data for Way2Will app

export interface Task {
    id: string;
    title: string;
    timeStart?: string;
    timeEnd?: string;
    priority: 'high' | 'medium' | 'normal';
    context: string;
    contextColor: string;
    contextBgColor: string;
    completed: boolean;
}

export interface UpcomingTask {
    id: string;
    title: string;
    dateTime: string;
    priority: 'high' | 'medium' | 'normal';
}

export interface Integration {
    id: string;
    name: string;
    icon: string;
    status: 'connected' | 'disconnected';
    lastSync?: string;
    workspaces?: number;
}

export interface UserProfile {
    name: string;
    email: string;
    avatar: string;
    plan: 'Free' | 'Pro' | 'Team';
    trialDaysLeft?: number;
}

export interface UserStats {
    tasksCompleted: number;
    timeSavedHours: number;
    currentStreak: number;
}

// Mock Tasks
export const mockTasks: Task[] = [
    {
        id: '1',
        title: 'Call John re: Q3 Report',
        timeStart: '10:00 AM',
        timeEnd: '10:30 AM',
        priority: 'high',
        context: 'Work',
        contextColor: '#2A7A85',
        contextBgColor: '#D9EEF2',
        completed: false,
    },
    {
        id: '2',
        title: 'Review marketing launch materials',
        timeStart: '2:00 PM',
        timeEnd: '3:00 PM',
        priority: 'medium',
        context: 'Marketing Launch',
        contextColor: '#FFFFFF',
        contextBgColor: '#8B9FD8',
        completed: false,
    },
    {
        id: '3',
        title: 'Respond to client emails',
        timeStart: '4:00 PM',
        timeEnd: '4:30 PM',
        priority: 'normal',
        context: 'Email',
        contextColor: '#3DA58A',
        contextBgColor: '#D5F2EA',
        completed: false,
    },
    {
        id: '4',
        title: 'Workout',
        timeStart: '6:00 PM',
        timeEnd: '7:00 PM',
        priority: 'normal',
        context: 'Personal',
        contextColor: '#E8A547',
        contextBgColor: '#FFF4E5',
        completed: false,
    },
];

// Mock Upcoming Tasks
export const mockUpcomingTasks: UpcomingTask[] = [
    {
        id: '5',
        title: 'Team standup meeting',
        dateTime: 'Tomorrow, 9:00 AM',
        priority: 'high',
    },
    {
        id: '6',
        title: 'Prepare quarterly review',
        dateTime: 'Tomorrow, 2:00 PM',
        priority: 'medium',
    },
];

// Mock User Profile
export const mockUserProfile: UserProfile = {
    name: 'Marcus Johnson',
    email: 'marcus@company.com',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face',
    plan: 'Pro',
    trialDaysLeft: undefined,
};

// Mock User Stats
export const mockUserStats: UserStats = {
    tasksCompleted: 47,
    timeSavedHours: 12,
    currentStreak: 14,
};

// Mock Integrations
export const mockIntegrations: Integration[] = [
    {
        id: '1',
        name: 'Google Calendar',
        icon: 'logos:google-calendar',
        status: 'connected',
        lastSync: '2 min ago',
    },
    {
        id: '2',
        name: 'Gmail',
        icon: 'logos:google-gmail',
        status: 'connected',
        lastSync: '5 min ago',
    },
    {
        id: '3',
        name: 'Slack',
        icon: 'logos:slack-icon',
        status: 'connected',
        workspaces: 2,
    },
];

// Helper to get priority color
export function getPriorityColor(priority: Task['priority']): string {
    switch (priority) {
        case 'high':
            return '#D66B5C';
        case 'medium':
            return '#E8A547';
        default:
            return 'transparent';
    }
}
